import React, { useEffect } from "react"
import styled from "styled-components"

const Circuit = ({ title, rounds, exercises }) => {
  useEffect(() => {
    exercises.forEach(e => {
      const video = document.getElementById(`circuit-video-${e.id}`)
      video.muted = true
      video.autoplay = true
      video.loop = true
      video.setAttribute("playsinline", true)
    })
  }, [exercises])

  return (
    <Container>
      <h2 id={title.toLowerCase().replace(/ /g, "-")}>{title}</h2>
      <p>Complete {rounds} rounds</p>
      <ExerciseGrid
        exercises={exercises}
      >
        {exercises.map(
          (
            {
              id,
              video_url,
              name,
              volume,
              volume_unit,
              intensity,
              intensity_unit,
            },
            index
          ) => (
            <Exercise key={`${id}`}>
              <Video id={`circuit-video-${id}`} controlList="nodownload">
                <source src={video_url} type="video/mp4" />
              </Video>
              <h4>
                {index + 1}. {name}
              </h4>
              {volume_unit === "s" && (
                <div>
                  Hold for {volume} seconds{" "}
                  {intensity ? `with ${intensity}${intensity_unit}` : null}
                </div>
              )}
              {volume_unit === "x" && (
                <div>
                  Complete {volume} repetitions{" "}
                  {intensity ? `with ${intensity}${intensity_unit}` : null}
                </div>
              )}
              {volume_unit === "m" && (
                <div>
                  Move for {volume} meters{" "}
                  {intensity ? `with ${intensity}${intensity_unit}` : null}
                </div>
              )}
            </Exercise>
          )
        )}
      </ExerciseGrid>
    </Container>
  )
}

const Container = styled.div`
  margin: 0;
  padding: 2em 0px 110px;
  margin: 2em 0;
  
  h2 {
    color: var(--white);
  }

  p {
    margin-bottom: 30px !important;
    color: var(--white);
  }

  div {
    margin-right: 0;
    width: 100%;
  }

  @media (max-width: 1200px) {
    max-width: 1000px;
    margin: 100px auto;
    padding: 60px 0 110px;
  }

  @media (max-width: 900px) {
    max-width: 640px;
    margin: 50px auto;
    padding: 10px 0 50px;
  }
`

const ExerciseGrid = styled.div`
  display: grid;
  grid-gap: 30px;
  grid-template-columns: ${({exercises}) => exercises.map(e => "1fr ")};
  grid-row: auto;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`

const Exercise = styled.div`
  h4 {
    margin: 5px 0 0;
    color: var(--white);
  }
  div {
    margin-top: 2px;
    color: var(--light-grey);
  }
`

const Video = styled.video`
  width: 100%;
  margin: 0;
  padding: 0;
  margin-bottom: 0;
  border-radius: 12px;
`

export default Circuit
